import React from "react";
import classnames from "classnames";
import { useTranslation } from "@helpers/translate";
import { LogoIcon } from "@components/library";
import { formatSignedPnl, getTone } from "../../../../Orders/positionFormat";
import { formatMultiplier } from "../../utils/tradeMath";
import "./TradeResult.sass";

/**
 * P&L and multiplier the replay is at, under the logo.
 *
 * @param {object} props
 * @param {number|null} props.pnl
 * @param {number|null} props.multiplier
 * @param {boolean} props.isDemo trade of the demo account
 */
export const TradeResult = ({ pnl, multiplier, isDemo }) => {
  const { __ } = useTranslation();
  const tone = getTone(pnl);

  return (
    <div className="trade-result">
      <span className="trade-result__logo">
        <LogoIcon forceFullLogo />
      </span>

      <p className="trade-result__values">
        <span
          className={classnames("trade-result__pnl", {
            [`trade-result__pnl--${tone}`]: tone,
          })}
        >
          {formatSignedPnl(pnl)}
        </span>
        <span className="trade-result__multiplier">
          {formatMultiplier(multiplier)}
        </span>
      </p>

      {isDemo && (
        <span className="trade-result__demo">
          {__("futures.trade_details.demo_account")}
        </span>
      )}
    </div>
  );
};
